import { render, staticRenderFns } from "./editRole.vue?vue&type=template&id=19e41256&scoped=true&"
import script from "./editRole.vue?vue&type=script&lang=js&"
export * from "./editRole.vue?vue&type=script&lang=js&"
import style0 from "./editRole.vue?vue&type=style&index=0&id=19e41256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e41256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e41256')) {
      api.createRecord('19e41256', component.options)
    } else {
      api.reload('19e41256', component.options)
    }
    module.hot.accept("./editRole.vue?vue&type=template&id=19e41256&scoped=true&", function () {
      api.rerender('19e41256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/editRole.vue"
export default component.exports